import { Box, FormLabel, InputLabel, MenuItem, Select } from '@mui/material';
import { FormData, openAiModelsImage } from './constants';

export const OpenAIImageSizes = ['auto', '1024x1024', '1536x1024', '1024x1536'];

type OpenAiImgProps = {
  formData: FormData;
  onChange: (e: any) => void;
};

const OpenAiImg = ({ formData, onChange }: OpenAiImgProps) => {
  return (
    <Box display={'flex'} flexDirection={'column'} gap={'16px'}>
      <Box mt={'8px'}>
        <InputLabel htmlFor='aiModel'>Open AI Models</InputLabel>
        <Select
          value={formData.aiModel}
          onChange={onChange}
          className='nodrag'
          fullWidth
          name='aiModel'
          sx={{
            width: '100%',
          }}
        >
          {openAiModelsImage.map(type => (
            <MenuItem key={type.value} value={type.value}>
              {type.name}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box mt={'8px'}>
        <InputLabel htmlFor='quality'>Quality</InputLabel>

        <Select
          value={formData.quality}
          onChange={onChange}
          className='nodrag'
          fullWidth
          name='quality'
          sx={{
            width: '100%',
          }}
        >
          <MenuItem key={'high'} value={'high'}>
            high
          </MenuItem>

          <MenuItem key={'medium'} value={'medium'}>
            medium
          </MenuItem>

          <MenuItem key={'low'} value={'low'}>
            low
          </MenuItem>
        </Select>
      </Box>

      <Box>
        <FormLabel htmlFor='size'>Size</FormLabel>

        <Select
          value={formData.size}
          onChange={onChange}
          fullWidth
          className='nodrag'
          name='size'
          sx={{
            marginLeft: '8px',
            width: '200px',
          }}
        >
          {OpenAIImageSizes.map(size => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
};

export default OpenAiImg;
